import { Observable, map, take } from 'rxjs';
import { inject } from '@angular/core';

import { UserDetailsFacade } from '@shared/state/facades';
import { CanActivateFn, CanMatchFn } from '@shared/models/guard';

export const canActivateClientGuard: CanActivateFn = (): Observable<boolean> =>
  hasClientId();
export const canMatchClientGuard: CanMatchFn = (): Observable<boolean> =>
  hasClientId();

const hasClientId = (): Observable<boolean> => {
  const userDetailsFacade = inject(UserDetailsFacade);

  return userDetailsFacade.query.selectedClientId$.pipe(
    take(1),
    map((clientId) => !!clientId)
  );
};
